module.exports = __webpack_public_path__ + "img/Bodyswaps_WO.a1cc6b01.svg";